import React from 'react';
import PropTypes from 'prop-types';

export default function UserIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <g data-name='usuarios'>
        <g fill={fill} data-name='Grupo 152739'>
          <path
            d='M17.225 13.213a2.911 2.911 0 0 0-1.829-5.178 3.432 3.432 0 0 0-.589.062c-.031 0-.062.031-.093.031a3.045 3.045 0 0 0-.5.155h-.031a3.158 3.158 0 0 0-.93.651 2.869 2.869 0 0 0-.806 1.985 3.8 3.8 0 0 0 .062.589 2.98 2.98 0 0 0 .341.868c.031.031.062.093.093.124a3.114 3.114 0 0 0 .589.682 4.34 4.34 0 0 0-1.861 3.938v1.333h7.318V17.12a4.087 4.087 0 0 0-1.764-3.907Z'
            data-name='Caminho 11903'
          />
          <path
            d='M8.275 7.178a2.86 2.86 0 0 0-.93.9 4.081 4.081 0 0 1 1.4 3.039 4.6 4.6 0 0 1-.093.589h2.884a3.347 3.347 0 0 1-.093-.589 4.081 4.081 0 0 1 1.4-3.039 3.633 3.633 0 0 0-.93-.9 2.931 2.931 0 1 0-3.628 0Z'
            data-name='Caminho 11904'
          />
          <path
            d='M6.551 13.213a2.461 2.461 0 0 0 .589-.682c.031-.031.062-.093.093-.124a2.982 2.982 0 0 0 .341-.868 3.434 3.434 0 0 0 .062-.589 2.869 2.869 0 0 0-.806-1.985 2.519 2.519 0 0 0-.93-.651h-.031a2.32 2.32 0 0 0-.5-.155c-.031 0-.062-.031-.093-.031a3.8 3.8 0 0 0-.589-.062 2.911 2.911 0 0 0-2.915 2.915 3 3 0 0 0 1.085 2.264 4.34 4.34 0 0 0-1.861 3.938v1.333h7.318v-1.333a4.133 4.133 0 0 0-1.763-3.97Z'
            data-name='Caminho 11905'
          />
        </g>
        <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
      </g>
    </svg>
  );
}

UserIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

UserIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
